var exports = {
  "mY": "infoPanelContainer__gopRE5",
  "qP": "infoPanelContent__4R8yES",
  "If": "infoPanelHeader__M2vUc7",
  "AN": "headerSpacer__l4a8C-",
  "Vs": "infoPanelTitle__Cz6Xqx",
  "Mw": "agentTaskPanelContainer__2neAOX",
  "XC": "descriptionEditorContainer__mOQG1M",
  "bu": "itemDetailsContainer__PqyQey",
  "wd": "itemMainContent__GScrue",
  "Vy": "developmentWarningContainer__ukwZMe",
  "Zl": "developmentWarningHeader__O_RUV4",
  "mq": "developmentWarningFlash__ki-QH3",
};

module.exports = exports;
